export default __webpack_public_path__ + "static/media/gallery-wip-handle_03.e269c052.jpg";